import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { Card } from 'modules/common';
import { defiRoutesConfig } from 'modules/defi';
import {
  globalTranslation,
  mergeTranslations,
  useTranslation,
} from 'modules/i18n';
import { ExternalLinkIcon } from 'modules/icons';

import EarnIcon from './assets/earn.svg?react';
import PointsIcon from './assets/points.svg?react';
import { translation } from './translation';

const mergedTranslation = mergeTranslations(globalTranslation, translation);
const LIQUID_LINK = 'https://iota.liquidlink.io/';

export function EarnMore(): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(mergedTranslation);

  return (
    <Card className={classes.root} wrapClassName={classes.wrapClassName}>
      <div className={classes.item}>
        <div className={classes.earn}>
          <EarnIcon />

          <span>{t(keys.earnMore)}</span>
        </div>

        <Link
          className={classes.explore}
          to={defiRoutesConfig.defi.generatePath()}
        >
          <span>{t(keys.explore)}</span>

          <ExternalLinkIcon className={classes.icon} />
        </Link>
      </div>

      <Divider orientation="horizontal" sx={{ my: 6 }} />

      <div className={classes.item}>
        <div className={classes.earn}>
          <PointsIcon />

          <span>{t(keys.points)}</span>
        </div>

        <a
          className={classes.explore}
          href={LIQUID_LINK}
          rel="noreferrer"
          target="_blank"
        >
          <span>{t(keys.liquidLink)}</span>

          <ExternalLinkIcon className={classes.icon} />
        </a>
      </div>
    </Card>
  );
}

const useStyles = makeStyles()(theme => ({
  root: {
    flexDirection: 'column',
    height: 'auto',
  },

  item: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),

    justifyContent: 'space-between',
  },

  wrapClassName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  earn: {
    fontSize: 20,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      fontWeight: 400,
    },
  },

  explore: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    fontSize: 16,
    gap: theme.spacing(1),
  },

  icon: {
    width: 20,
  },
}));
